import React from "react";
import svgMap from "assets/services/svgMap"; // Make sure to update the path accordingly
import styles from "./styles.module.scss"; // Import your styles

const ServiceSvgIcon = ({
  iconPath,
  color,
  fillColor,
  size = "medium",
  className = "",
}) => {
  // Clean the icon path (e.g., '/img/assets//static/services/reservation/cafe.svg' => 'reservation/cafe')
  const cleanedPath = iconPath
    .replace("/img/assets//static/services/", "") // Remove the base path part
    .replace(".svg", ""); // Remove the .svg extension

  // Get the corresponding SVG component from the map
  const IconComponent = svgMap[cleanedPath] || svgMap["free/signaletique"];

  // If the icon is not found, return null (or you can render a placeholder icon)
  if (!IconComponent) {
    return null;
  }

  const sizeStyles = {
    small: { width: "24px", height: "24px" },
    medium: { width: "32px", height: "32px" }, // Default size
    large: { width: "50px", height: "50px" },
  };

  return (
    <div
      className={`${styles.svgWrapper} ${className} ${styles[size]}`.trim() }
      style={{
        ...sizeStyles[size],
      }}
    >
      <IconComponent
        className={`${styles.svgIcon}`} // Apply class to the SVG icon
        style={{
          fill: fillColor || "white", // Apply the color for fill
          stroke: color || "var(--main-color, #d51b81)",
          // ...sizeStyles[size],

        }}
      />
    </div>
  );
};

export default ServiceSvgIcon;
